<template>
  <v-alert type="error" dismissible class="app-alert" v-show="appError">
    {{ appError }}
  </v-alert>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["appError"])
  }
};
</script>

<style scoped>
.app-alert {
  position: fixed;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  max-width: 100%;
}
</style>
